var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccountOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.243 2 7 4.243 7 7C7 9.757 9.243 12 12 12C14.757 12 17 9.757 17 7C17 4.243 14.757 2 12 2ZM17.5 12C14.4625 12 12 14.4625 12 17.5C12 20.5375 14.4625 23 17.5 23C20.5375 23 23 20.5375 23 17.5C23 14.4625 20.5375 12 17.5 12ZM6.25 14C5.0095 14 4 15.0095 4 16.25V16.8496C4 19.7376 7.514 22 12 22C12.2685 22 12.5329 21.9906 12.7939 21.9746C11.6854 20.8086 11 19.236 11 17.5C11 16.21 11.3803 15.011 12.0283 14H6.25ZM20.5 15C20.6279 15 20.7558 15.0487 20.8535 15.1465C21.049 15.342 21.049 15.658 20.8535 15.8535L16.8535 19.8535C16.756 19.951 16.628 20 16.5 20C16.372 20 16.244 19.951 16.1465 19.8535L14.1465 17.8535C13.951 17.658 13.951 17.342 14.1465 17.1465C14.342 16.951 14.658 16.951 14.8535 17.1465L16.5 18.793L20.1465 15.1465C20.2442 15.0487 20.3721 15 20.5 15Z",
    fill: "#03F5AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.243 2 7 4.243 7 7C7 9.757 9.243 12 12 12C14.757 12 17 9.757 17 7C17 4.243 14.757 2 12 2ZM6.25 14C5.0095 14 4 15.0095 4 16.25V16.8496C4 19.7376 7.514 22 12 22C12.2685 22 12.5329 21.9906 12.7939 21.9746C11.6854 20.8086 11 19.236 11 17.5C11 16.21 11.3803 15.011 12.0283 14H6.25Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOverview);
export default __webpack_public_path__ + "static/media/account_overview.1721094d0bcb033ff15556dddadc34c0.svg";
export { ForwardRef as ReactComponent };